import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../core/utils/material.module';
// import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { WjGridSheetModule } from "@grapecity/wijmo.angular2.grid.sheet";
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ErrorPopupComponent } from './error-popup/error-popup.component';
import { NotificationDialogComponent } from './notification-dialog/notification-dialog.component';
import { ExcelViewerComponent } from './excel-viewer/excel-viewer.component';
import { ExcelViewerOutputComponent } from './excel-viewer-output/excel-viewer-output.component';
import { CloseConfirmationComponent } from './close-confirmation/close-confirmation.component';
import { NgxLoadingModule } from 'ngx-loading';
import { PaginationComponent } from './wijmo-grid-pagination/pagination.component';
import { FormsModule } from '@angular/forms';
import { VirtualScrollComponent } from './virtual-scroll/virtual-scroll.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { XssValidatorDirective  } from './validators/xss-validator.directive';
@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        WjGridSheetModule,
        NgxLoadingModule.forRoot({}),
        FormsModule,
        ScrollingModule
        // NgxDatatableModule
    ],
    declarations: [
        ConfirmationDialogComponent,
        ErrorPopupComponent,
        NotificationDialogComponent,
        ExcelViewerComponent,
        ExcelViewerOutputComponent,
        CloseConfirmationComponent,
        PaginationComponent,
        VirtualScrollComponent,
        XssValidatorDirective
    ],
    exports: [
        ExcelViewerComponent,
        ExcelViewerOutputComponent,
        CloseConfirmationComponent,
        PaginationComponent,
        VirtualScrollComponent,
        XssValidatorDirective
        // NgxDatatableModule
    ]
})
export class SharedModule { }
